<template>
  <div class="main" v-title data-title="北京天蔚中医药发展促进中心-项目详情">
    <div class="swipe">
      <!-- <img src="http://123.56.170.62:9999/static/bg/banner7.png" alt /> -->
      <img src="../assets/banner9.png" alt />
    </div>
    <div class="program">
      <div class="showSomeProgram">
        <div class="pLeft">
          <img
            v-if="!programDetailData.video"
            :src="programDetailData.picture"
            alt
          />
          <div v-else class="video">
            <video-player
              class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              @pause="pausePlay($event)"
              :options="playerOptions"
            ></video-player>
          </div>
        </div>
        <div class="pRight">
          <h1>{{ programDetailData.name }}</h1>
          <div class="pShow">
            <h5>募捐编号</h5>
            <h4>{{ programDetailData.itemserial }}</h4>
          </div>
          <div class="pLine"></div>
          <div class="pShow">
            <h5>募捐时间</h5>
            <h4>{{ programDetailData.donatime }}</h4>
          </div>
          <div class="pLine"></div>
          <div class="pShow">
            <h5>捐赠次数</h5>
            <div class="den">
              <div class="denLeft">
                个人
                <span>{{ programDetailData.person }}</span>
              </div>
              <div class="denRight">
                团体
                <span>{{ programDetailData.team }}</span>
              </div>
            </div>
          </div>
          <div class="pBox">
            <div class="pBoxLeft">
              <el-progress
                :width="60"
                :stroke-width="3"
                type="circle"
                :percentage="programDetailData.bili"
              ></el-progress>
            </div>
            <div class="pBoxRight">
              <div class="pShow">
                <h5>募捐目标（元）</h5>
                <h3>{{ programDetailData.placement }}</h3>
              </div>
              <div class="pShow">
                <h5>已募捐额（元）</h5>
                <h4>{{ programDetailData.raisefund }}</h4>
              </div>
            </div>
          </div>
          <div class="pLine"></div>
          <div class="apply">
            <div class="applyLeft">捐赠要求:</div>
            <div class="showMore">
              <p class="applyRight">{{ programDetailData.donatefor }}</p>
              <el-popover
                style="align-self: flex-end"
                placement="left-start"
                title="捐赠要求"
                width="300"
                trigger="click"
                :content="programDetailData.donatefor"
              >
                <i slot="reference" class="el-icon-caret-bottom"></i>
              </el-popover>
            </div>
          </div>
          <div class="pLine"></div>
          <div class="apply">
            <div class="applyLeft">申请要求:</div>
            <div class="showMore">
              <p class="applyRight">{{ programDetailData.applyfor }}</p>
              <el-popover
                style="align-self: flex-end"
                placement="left-start"
                title="申请要求"
                width="300"
                trigger="click"
                :content="programDetailData.applyfor"
              >
                <i slot="reference" class="el-icon-caret-bottom"></i>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
      <div class="ProgramDetail">
        <div class="pDetailLeft">
          <div class="pDetailLeftContent">
            <h2>项目详情</h2>
            <div class="pContent" v-html="programDetailData.donateask"></div>
          </div>
        </div>
        <div class="pDetailRight">
          <div class="love">
            <div class="loveContent">
              <div class="loveHeader">
                <h3>爱心榜</h3>
              </div>
              <div class="user">
                <el-table
                  ref="multipleTable"
                  :data="tableData"
                  tooltip-effect="dark"
                  style="width: 100%"
                >
                  <!-- <el-table-column
                    label="排名"
                    type="index"
                    :index="indexMethod"
                    align="center"
                    min-width="25%"
                  ></el-table-column> -->
                  <el-table-column label="排名" align="center" min-width="10%">
                    <template slot-scope="scope">
                      {{ scope.$index + 1 }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="姓名"
                    align="center"
                    min-width="10%"
                  ></el-table-column>
                  <el-table-column
                    prop="money"
                    label="金额"
                    align="center"
                    min-width="15%"
                  ></el-table-column>
                  <el-table-column
                    prop="donortime"
                    label="时间"
                    align="center"
                    min-width="20%"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="love">
            <div class="loveContent">
              <div class="loveHeader">
                <h3>募捐记录</h3>
              </div>
              <div class="user">
                <el-table
                  ref="multipleTable"
                  :data="jztableData"
                  tooltip-effect="dark"
                  style="width: 100%"
                >
                  <el-table-column label="序号" align="center" min-width="10%">
                    <template slot-scope="scope">
                      {{
                        scope.$index + 1 + (jzpaginations.page_index - 1) * 10
                      }}
                    </template>
                  </el-table-column>
                  <!-- <el-table-column
                    label="序号"
                    type="index"
                    :index="jzindexMethod"
                    align="center"
                    min-width="5%"
                  ></el-table-column> -->
                  <el-table-column
                    prop="name"
                    label="捐赠人"
                    align="center"
                    min-width="15%"
                  ></el-table-column>
                  <el-table-column
                    prop="money"
                    label="捐赠金额"
                    align="center"
                    min-width="15%"
                  ></el-table-column>
                  <el-table-column
                    prop="donortime"
                    label="时间"
                    align="center"
                    min-width="20%"
                  ></el-table-column>
                </el-table>
              </div>
              <div
                class="tspage"
                v-if="jzpaginations.total > jzpaginations.page_size"
              >
                <el-pagination
                  background
                  :pager-count="3"
                  @current-change="jzhandleCurrentChange"
                  :current-page.sync="jzpaginations.page_index"
                  :page-size="jzpaginations.page_size"
                  :total="jzpaginations.total"
                  layout="prev, pager, next"
                ></el-pagination>
              </div>
            </div>
          </div>
          <div class="love">
            <div class="loveContent">
              <div class="loveHeader">
                <h3>资助记录</h3>
              </div>
              <div class="user">
                <el-table
                  ref="multipleTable"
                  :data="sztableData"
                  tooltip-effect="dark"
                  style="width: 100%"
                >
                  <!-- <el-table-column
                    label="序号"
                    type="index"
                    :index="szindexMethod"
                    align="center"
                    min-width="30%"
                  ></el-table-column> -->
                  <el-table-column label="序号" align="center" min-width="10%">
                    <template slot-scope="scope">
                      {{
                        scope.$index + 1 + (szpaginations.page_index - 1) * 10
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="受助人"
                    align="center"
                    min-width="15%"
                  ></el-table-column>
                  <el-table-column
                    prop="money"
                    label="受助金额"
                    align="center"
                    min-width="15%"
                  ></el-table-column>
                  <el-table-column
                    prop="donortime"
                    label="时间"
                    align="center"
                    min-width="20%"
                  ></el-table-column>
                </el-table>
              </div>
              <div
                class="tspage"
                v-if="szpaginations.total > szpaginations.page_size"
              >
                <el-pagination
                  background
                  :pager-count="3"
                  @current-change="szhandleCurrentChange"
                  :current-page.sync="szpaginations.page_index"
                  :page-size="szpaginations.page_size"
                  :total="szpaginations.total"
                  layout="prev, pager, next"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountTo from "@/components/count-to"
import { getProgramList, getJzUserList, getSzUserList } from "@/api/user.js"
import { BASE_URL, moneyFormat } from "@/utils/base.js"
import Bus from "@/utils/bus.js"
import { videoPlayer } from "vue-video-player"
export default {
  name: "Home",
  data() {
    return {
      pnav: [],
      pcurrentIndex: 0,
      realPcurrentIndex: 0,
      pscurrentIndex: 0,
      programData: {},
      jzpaginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      szpaginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      tableData: [],
      jztableData: [],
      sztableData: [],
      programDetailData: {},
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            //类型
            type: "video/mp4",
            //url地址
            src: "",
          },
        ],
        //你的封面地址
        poster: "",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true,
        },
      },
    }
  },
  created() {
    this.getOneProgram()
    this.getJzList()
    this.getSzList()
    this.getLove()
  },
  mounted() {
    window.scrollTo({
      top: 0,
    })
    this.$nextTick(function() {
      Bus.$emit("getCurrent", "hzzx")
    })
  },
  methods: {
    // 获取项目详情
    async getOneProgram() {
      let programId = new FormData()
      programId.append("sids", this.$route.params.id)
      let programDetail = await getProgramList(programId)
      this.programDetailData = programDetail
      if (this.programDetailData.video) {
        this.programDetailData.video = BASE_URL + this.programDetailData.video
        this.playerOptions.sources[0].src = this.programDetailData.video
      }
      if (this.programDetailData.picture) {
        this.programDetailData.picture =
          BASE_URL + this.programDetailData.picture
      }
      this.programDetailData.bili = Number(
        (
          (this.programDetailData.raisefund /
            this.programDetailData.placement) *
          100
        ).toFixed(2)
      )
      this.programDetailData.raisefund = moneyFormat(
        this.programDetailData.raisefund,
        2
      )
      this.programDetailData.placement = moneyFormat(
        this.programDetailData.placement,
        2
      )
      this.programDetailData.person = moneyFormat(
        this.programDetailData.person,
        0
      )
      this.programDetailData.team = moneyFormat(this.programDetailData.team, 0)
    },
    // 获取爱心榜列表
    async getLove() {
      let userList = new FormData()
      // userList.append("dentity", this.dentityNav[this.dentityIndex]);
      userList.append("page", 1)
      userList.append("rows", 10)
      userList.append("keyword", this.$route.params.id)
      userList.append("sids", 2)
      userList.append("school", "金额")
      let listInfo = await getJzUserList(userList)
      this.paginations.total = listInfo.total
      this.tableData = listInfo.rows
      this.tableData.map((item) => {
        item.donortime = item.donortime.substring(0, 10)
      })
    },
    // 获取捐赠人员列表
    async getJzList() {
      let userList = new FormData()
      // userList.append("dentity", this.dentityNav[this.dentityIndex]);
      userList.append("page", this.jzpaginations.page_index)
      userList.append("rows", this.jzpaginations.page_size)
      userList.append("keyword", this.$route.params.id)
      userList.append("xueyuan", 2)
      let listInfo = await getJzUserList(userList)
      this.jzpaginations.total = listInfo.total
      this.jztableData = listInfo.rows
      this.jztableData.map((item) => {
        item.donortime = item.donortime.substring(0, 10)
      })
    },
    // 获取受助人员列表
    async getSzList() {
      let userList = new FormData()
      userList.append("page", this.szpaginations.page_index)
      userList.append("rows", this.szpaginations.page_size)
      userList.append("keyword", this.$route.params.id)
      userList.append("xueyuan", 2)
      let listInfo = await getSzUserList(userList)
      this.szpaginations.total = listInfo.total
      this.sztableData = listInfo.rows
      this.sztableData.map((item) => {
        item.donortime = item.donortime.substring(0, 10)
      })
    },
    pausePlay(player) {
      //关闭弹窗-停止播放
      this.player.pause()
    },
    // 表格序号
    szindexMethod(index) {
      return index + (this.szpaginations.page_index - 1) * 10 + 1
    },
    indexMethod(index) {
      return index + (this.paginations.page_index - 1) * 10 + 1
    },
    jzindexMethod(index) {
      return index + (this.jzpaginations.page_index - 1) * 10 + 1
    },
    // 分页
    szhandleCurrentChange(val) {
      this.szpaginations.page_index = val
      this.getSzList()
    },
    // 分页
    jzhandleCurrentChange(val) {
      this.jzpaginations.page_index = val
      this.getJzList()
    },
  },
  computed: {
    // 视频
    player() {
      return this.$refs.videoPlayer.player
    },
  },
  components: { CountTo, videoPlayer },
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  .swipe {
    width: 100%;
    img {
      width: 100%;
      height: 400px;
    }
  }
  .program {
    padding-bottom: 42px;
    width: 100%;
    background-color: #fff;
    .showSomeProgram {
      width: 857px;
      margin: 40px auto;
      display: flex;
      .pLeft {
        width: 367px;
        height: 360px;
        margin-right: 30px;
        img {
          margin-top: 80px;
          width: 100%;
          height: 200px;
        }
        .video {
          margin-top: 80px;
          width: 100%;
          height: 200px;
        }
      }
      .pRight {
        width: 460px;

        h1 {
          width: 100%;
          height: 26px;
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 30px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
        }
        .pShow {
          display: flex;
          font-size: 16px;
          line-height: 3;
          h5 {
            width: 130px;
            color: #aaa;
          }
          h4 {
            font-weight: 600;
          }
          .den {
            display: flex;
            color: #aaa;
            font-size: 16px;
            .denLeft {
              width: 130px;
              span {
                color: #0687c8;
              }
            }
            .denRight {
              padding-left: 50px;
              span {
                color: #0687c8;
              }
            }
          }
        }
        .pLine {
          width: 100%;
          height: 1px;
          margin: 0;
          background-color: #ebebeb;
        }
        .pBox {
          margin: 2px 0 15px;
          width: 100%;
          height: 80px;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          display: flex;
          .pBoxLeft {
            width: 100px;
            height: 80px;
            margin-right: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            /deep/ .el-progress-circle {
              width: 60px !important;
              height: 60px !important;
            }
            /deep/ .el-progress__text {
              font-size: 10px !important;
            }
          }
          .pBoxRight {
            display: flex;
            flex-direction: column;
            justify-content: center;
            .pShow {
              display: flex;
              font-size: 16px;
              line-height: 2;
              h5 {
                width: 130px;
                color: #aaa;
              }
              h4 {
                color: #ff2f4c;
                font-weight: 600;
              }
              h3 {
                color: #0687c8;
                font-weight: 600;
              }
            }
          }
        }

        .apply {
          height: 64px;
          padding: 10px 0;
          display: flex;
          color: #aaa;
          font-size: 16px;
          line-height: 2;
          .applyLeft {
            width: 90px;
          }
          .showMore {
            display: flex;
            .applyRight {
              width: 360px;
              max-height: 64px;
              word-wrap: break-word;
              word-break: break-all;
              overflow: hidden;
            }
            i {
              font-size: 26px;
              color: #3b3b3b;
              cursor: pointer;
              align-self: flex-end;
            }
          }
        }
      }
    }
    .ProgramDetail {
      width: 877px;
      margin: 30px auto;
      display: flex;
      .pDetailLeft {
        width: 475px;
        border: 1px solid #dedede;
        border-radius: 5px;
        margin-right: 20px;
        .pDetailLeftContent {
          margin: 0 20px;
          padding: 20px 0;
          h2 {
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 20px;
          }
          .pContent {
            line-height: 2;
          }
        }
      }
      .pDetailRight {
        .love {
          margin-bottom: 20px;
          width: 380px;
          border: 1px solid #dedede;
          border-radius: 5px;
          .loveContent {
            width: 320px;
            margin: 20px 30px;
            .loveHeader {
              width: 320px;
              height: 50px;
              background: url("../assets/paihang.png");
              background-size: 320px 50px;
              h3 {
                width: 320px;
                font-size: 20px;
                color: #fff;
                text-align: center;
                padding-top: 8px;
              }
            }
            .tspage {
              margin: 30px 0 20px;
              text-align: center;
              /deep/.el-pagination.is-background
                .el-pager
                li:not(.disabled).active {
                background-color: #0687c8;
                border: none;
              }
              /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
                background-color: #fff; // 进行修改未选中背景和字体
                border: 1px solid #ededed;
                // color: #fff;
              }
              /deep/ .el-pagination.is-background button {
                background-color: #fff; // 进行修改未选中背景和字体
                border: 1px solid #ededed;
                // color: #fff;
              }
            }
          }
        }
      }
    }
  }
}
</style>
